import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { useDataGridAutoHeightToScroll } from '~/components/SolaForceDataGrid/hooks/useDataGridAutoHeightToScroll';
import { SolaForceHeading } from '~/components/SolaForceHeading';
import { useReadOnlyDocumentsTable } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/ReadOnlyDocumentsTable/useReadOnlyDocumentsTable';
import { useReadOnlyDocumentsTableColumns } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/ReadOnlyDocumentsTable/useReadOnlyDocumentsTableColumns';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

export const ReadOnlyDocumentsTable = () => {
  const { t } = useTranslation();

  const { isLoading, documents, documentTypes, selectedEmployeeId } =
    useReadOnlyDocumentsTable();

  const { columns } = useReadOnlyDocumentsTableColumns({
    selectedEmployeeId,
    documentTypes,
  });

  const { dataGridProps: autoHeightProps, containerProps } =
    useDataGridAutoHeightToScroll({
      rowsCount: documents.length,
      settings: {
        scrollRowCount: 10,
        rowHeight: 36,
        headerRowHeight: 39,
      },
    });

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <Box>
      <SolaForceHeading heading={t('laEmpDocsReadOnly')}></SolaForceHeading>
      <Box {...containerProps}>
        <DataGridPro
          columns={columns}
          rows={documents}
          {...autoHeightProps}
          density={'compact'}
          hideFooter={true}
        />
      </Box>
    </Box>
  );
};
